(function (){
  'use strict';

  angular.module('nv-data-tools-portal').config(themeConfig);

  //COLOR PALETTE
  function themeConfig($mdThemingProvider) {

    $mdThemingProvider
      .definePalette('nvBlue', {
        '50': '#37adff',
        '100': '#1ea3ff',
        '200': '#0498ff',
        '300': '#008aea',
        '400': '#007bd0',
        '500': '#006CB7',
        '600': '#005d9d',
        '700': '#004e84',
        '800': '#003f6a',
        '900': '#003051',
        'A100': '#2196f3',
        'A200': '#6ac2ff',
        'A400': '#84cdff',
        'A700': '#002137',

        'contrastDefaultColor': 'light', // whether, by default, text (contrast on this palette should be dark or light)

        'contrastDarkColors': undefined, //hues which contrast should be 'dark' by default

        'contrastLightColors': undefined // could also specify this if default was 'dark'
      })


      .definePalette('nvYellow', {
        '50': '#573e00',
        '100': '#705000',
        '200': '#8a6200',
        '300': '#a37400',
        '400': '#bd8700',
        '500': '#d69900',
        '600': '#ffb90a',
        '700': '#ffc024',
        '800': '#ffc73d',
        '900': '#ffcf57',
        'A100': '#ffb90a',
        'A200': '#F0AB00',
        'A400': '#d69900',
        'A700': '#ffd670',

        'contrastDefaultColor': 'dark', // whether, by default, text (contrast on this palette should be dark or light)
        'contrastDarkColors': undefined, //hues which contrast should be 'dark' by default
        'contrastLightColors': undefined // could also specify this if default was 'dark'
      })

      .definePalette('nvRed', {
        '50': '#f07f83',
        '100': '#ed686d',
        '200': '#eb5257',
        '300': '#e83b41',
        '400': '#e6242b',
        '500': '#D71920',
        '600': '#c0161d',
        '700': '#a91419',
        '800': '#921116',
        '900': '#7c0e12',
        'A100': '#f3969a',
        'A200': '#f5adb0',
        'A400': '#f8c4c6',
        'A700': '#650c0f',

        'contrastDefaultColor': 'light', // whether, by default, text (contrast on this palette should be dark or light)
        'contrastDarkColors': undefined, //hues which contrast should be 'dark' by default
        'contrastLightColors': undefined // could also specify this if default was 'dark'
      })

      .definePalette('nvPurple', { //not in use
        '50': '#a56ad1',
        '100': '#9956cc',
        '200': '#8d43c6',
        '300': '#8038b7',
        '400': '#7332a4',
        '500': '#652C90',
        '600': '#57267c',
        '700': '#4a2069',
        '800': '#3c1a55',
        '900': '#2e1442',
        'A100': '#b17ed7',
        'A200': '#bd91dd',
        'A400': '#c8a5e3',
        'A700': '#200e2e',

        'contrastDefaultColor': 'light', // whether, by default, text (contrast on this palette should be dark or light)
        'contrastDarkColors': undefined, //hues which contrast should be 'dark' by default
        'contrastLightColors': undefined // could also specify this if default was 'dark'
      })

      .definePalette('nvGreen', { //not in use
        '50': '#1bff85',
        '100': '#02ff78',
        '200': '#00e76c',
        '300': '#00ce60',
        '400': '#00b454',
        '500': '#009B48',
        '600': '#00813c',
        '700': '#006830',
        '800': '#004e24',
        '900': '#003519',
        'A100': '#35ff93',
        'A200': '#4effa0',
        'A400': '#68ffae',
        'A700': '#001b0d',

        'contrastDefaultColor': 'light', // whether, by default, text (contrast on this palette should be dark or light)
        'contrastDarkColors': undefined, //hues which contrast should be 'dark' by default
        'contrastLightColors': undefined // could also specify this if default was 'dark'
      })

      .definePalette('nvGray', {
        '50': '#d5d9de',
        '100': '#c7ccd3',
        '200': '#b9bfc8',
        '300': '#abb2bc',
        '400': '#9ca5b1',
        '500': '#8E98A6',
        '600': '#808b9b',
        '700': '#717e90',
        '800': '#667181',
        '900': '#5b6573',
        'A100': '#e4e6e9',
        'A200': '#f2f3f5',
        'A400': '#ffffff',
        'A700': '#505865',

        'contrastDefaultColor': 'light', // whether, by default, text (contrast on this palette should be dark or light)
        'contrastDarkColors': undefined, //hues which contrast should be 'dark' by default
        'contrastLightColors': undefined // could also specify this if default was 'dark'
      });

    $mdThemingProvider.theme('default')
      .primaryPalette('nvBlue')
      .accentPalette('nvYellow')
      .warnPalette('nvRed');
  }
}());
